import { VehiclesUtil } from '@/modules/vehicles/vehiclesUtil';

type ShuttleSelectionChange = {
  nextSelectedIds: string[];
  removedShuttleId?: string;
};

const isShuttleTypeId = (id: string): boolean => VehiclesUtil.isShuttleVehicle(id);

export const isShuttleVehicleId = (id: string): boolean => isShuttleTypeId(id);

export const isShuttleLoadCarrierId = (id: string): boolean => isShuttleTypeId(id);

export const getSelectedShuttleId = (selectedIds: string[]): string | undefined =>
  selectedIds.find(isShuttleTypeId);

export const getNonShuttleIds = (selectedIds: string[]): string[] =>
  selectedIds.filter((selectedId) => !isShuttleTypeId(selectedId));

export const removeSelectedShuttle = (selectedIds: string[]): string[] =>
  getNonShuttleIds(selectedIds);

export const setSelectedShuttle = (selectedIds: string[], shuttleId: string): string[] => [
  ...removeSelectedShuttle(selectedIds),
  shuttleId,
];

export const preserveSelectedShuttle = (
  selectedIds: string[],
  nextNonShuttleIds: string[],
): string[] => {
  const selectedShuttleId = getSelectedShuttleId(selectedIds);

  if (!selectedShuttleId) {
    return nextNonShuttleIds;
  }

  return [selectedShuttleId, ...nextNonShuttleIds];
};

export const getShuttleSelectionChange = (
  selectedIds: string[],
  shuttleId: string,
): ShuttleSelectionChange => {
  const selectedShuttleId = getSelectedShuttleId(selectedIds);

  if (selectedShuttleId === shuttleId) {
    return {
      nextSelectedIds: removeSelectedShuttle(selectedIds),
      removedShuttleId: shuttleId,
    };
  }

  return {
    nextSelectedIds: setSelectedShuttle(selectedIds, shuttleId),
    removedShuttleId: selectedShuttleId,
  };
};
